var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "password-reissue-body" }, [
    _c("div", { staticClass: "password-reissue-area" }, [
      _c("h4", { staticClass: "content-sub-title" }, [
        _vm._v(_vm._s(_vm.$t("password_reissue.done.send_mail_done")))
      ]),
      _vm._v(" "),
      _c("div", {
        staticClass: "password-reissue-description",
        domProps: {
          innerHTML: _vm._s(_vm.$t("password_reissue.done.description"))
        }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }